// empty file prevent babel-plugin-import error
import '../../../../lib/style/index.less';
// style dependencies
import '../../modal-container/style';
import '../../message/style';
